export default {
  props: {
    value: {
      type: [String, Number, Array, Object, Boolean],
      default: ''
    },
    options: {
      type: Object,
      default: () => ({})
    },
    rules: {
      type: Array,
      default: () => []
    },
    schemaId: {
      type: [Number, String],
      default: null
    }
  },
  methods: {
    input (e) {
      this.$emit('input', e)
    },
    enterDown (e) {
      this.$emit('enterDown', e)
    }
  }
}
